export default function ({state, commit, dispatch}, data) {
    window.app.$confirm('Вы действительно хотите удалить распределение?', 'Удаление путевки №' + data.Code, {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        commit('remove_agreement', data);
        dispatch('save');
        // axios({
        //     method: 'post',
        //     url: '/tourclient/api/giftCertificate/delete',
        //     data,
        //     requestId: 'tourclient/api/giftCertificate/delete'
        // }).then(({data}) => {
        //     cb(data);
        // }).catch(e => {
        //     context.dispatch('error', e, {root: true});
        // })
    }).catch(e => {
    });
}